import React, { useCallback } from 'react';

import { useCurrentProjectId } from '@adsk/alloy-provider';

import ListView from './components/ListView';
import TreeView from './components/TreeView';

const DocsCustomDataView = ({
  filters = {},
  setSelection,
  onRefreshEntities,
  ...rest
}) => {
  const projectId = useCurrentProjectId();
  const handleSetSelection = useCallback(
    (entities, keepExisting) => {
      setSelection(onRefreshEntities(entities), keepExisting);
    },
    [setSelection, onRefreshEntities],
  );

  if (filters.searchExpression) {
    return (
      <ListView
        projectId={projectId}
        filters={filters}
        setSelection={handleSetSelection}
        {...rest}
      />
    );
  }
  return (
    <TreeView
      projectId={projectId}
      setSelection={handleSetSelection}
      {...rest}
    />
  );
};

export default DocsCustomDataView;
